import isPropValid from "@emotion/is-prop-valid";
import React from "react";
import { StyleSheetManager, type WebTarget } from "styled-components";
import GlobalTheme from "./components/GlobalTheme";
import { GlobalConfig, GlobalConfigProvider } from "./context/GlobalConfig";
import { SEOConfig } from "./context/SEOContext";
import DevNav from "./views/DevNav";
import SEOHeading from "./views/SEOHeading";

export interface AppProps extends GlobalConfig, SEOConfig {
  path: string;
}

function shouldForwardProp(propName: string, target: WebTarget | undefined) {
  if (typeof target === "string") {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}

const App: React.FC<AppProps> = ({ brand, pageType, searchTerm, ...props }: AppProps) => {
  return (
    <StyleSheetManager enableVendorPrefixes shouldForwardProp={shouldForwardProp}>
      <GlobalTheme brand={brand} />
      <GlobalConfigProvider value={{ brand, pageType, searchTerm }}>
        <DevNav />
        <SEOHeading {...props} />
      </GlobalConfigProvider>
    </StyleSheetManager>
  );
};

export default App;
